import React from "react";

const InfoTag = ({ icon, label }: { icon: React.ReactNode; label: string }) => (
  <p className="flex items-center gap-2 rounded-[5px] py-1 text-sm">
    {icon}
    <span>{label}</span>
  </p>
);

export default InfoTag;
